import { Inject, Injectable } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthConfigService, OktaConfig } from '@okta/okta-angular';
import { DOCUMENT } from '@angular/common';

export interface ITransactionMetaCookieValue {
  codeVerifier: string;
  codeChallenge: string;
  codeChallengeMethod: string;
  state: string;
  nonce: string;
}

@Injectable({
  providedIn: 'root',
})
export class OktaInitializerService {
  constructor(
    private _oktaAuthConfigService: OktaAuthConfigService,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  setOktaConfiguration = async (oktaAuth: OktaAuth) => {
    // The following cookie values are set when
    // redirected to the Okta login page.
    const transactionMeta = this._getTransactionMeta(this._document);
    if (transactionMeta) {
      const meta = await oktaAuth.idx.createTransactionMeta({
        codeVerifier: transactionMeta.codeVerifier,
        codeChallenge: transactionMeta.codeChallenge,
        codeChallengeMethod: transactionMeta.codeChallengeMethod,
        state: transactionMeta.state,
      });
      oktaAuth.idx.saveTransactionMeta(meta);
    }
    const moduleConfig: OktaConfig = {
      oktaAuth,
    };
    this._oktaAuthConfigService.setConfig(moduleConfig);
  };

  private _getTransactionMeta(
    document: Document,
  ): ITransactionMetaCookieValue | null {
    if (!document.cookie) {
      return null;
    }
    const cookieValue = document.cookie
      .split('; ')
      .find((row) => row.startsWith('transactionMeta='));
    if (!cookieValue) {
      return null;
    }
    // Once the cookie is used, delete it because OktaAuth saves in localStorage.
    document.cookie =
      'transactionMeta=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure';
    const value = cookieValue.split('=')[1];
    if (!value.trim()) {
      return null;
    }
    const decodedValue = decodeURIComponent(value);
    return JSON.parse(decodedValue);
  }
}
